module.exports = __webpack_public_path__ + "static/miu-sk-7c18945b970121ba36246696c3b587d9.svg";